import type {
  AxisIdToCurrentScaleDomain,
  DOT_VARIANT,
  DotSeriesWithDatapoints,
  RECT_VARIANT,
  RectDatapointInternal,
  RectSeriesWithDatapoints,
} from './xy-chart-internals.js';
import type { DotDatapoint } from './xy-chart.js';
import type { AnnotationsIntegrationSelectionState } from '../../core/components/annotations/components/indicators/types.js';
import type {
  ExploreState,
  InteractionState,
} from '../../core/components/interactions-state-helpers/types.js';

type RectSeriesContent = {
  datapoint: RectDatapointInternal;
  series: RectSeriesWithDatapoints;
  type: typeof RECT_VARIANT;
};

export type DotSeriesContent = {
  datapoint: DotDatapoint;
  series: DotSeriesWithDatapoints;
  type: typeof DOT_VARIANT;
};

export const UndefinedContent = {
  datapoint: undefined,
  series: undefined,
  type: 'undefined',
} as const;

type TooltipContent = RectSeriesContent | DotSeriesContent;

export type XYChartExploreState = {
  content: TooltipContent | typeof UndefinedContent;
} & ExploreState;

export interface XYChartThresholdsState {
  hoveredThresholdId: string | undefined;
}

export interface XYChartState
  extends InteractionState<AxisIdToCurrentScaleDomain> {
  explore: XYChartExploreState;
  thresholds: XYChartThresholdsState;
  annotations: AnnotationsIntegrationSelectionState;
}
